<template>
  <el-dialog
    :title="model.id > 0 ? '编辑中间商' : '新增中间商'"
    :visible.sync="visible"
    width="960px"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
    append-to-body
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="120px"
      size="mini"
      class="form-flex"
    >
      <el-form-item label="名称" prop="name" class="long">
        <el-input v-model="model.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        v-if="auth.isPlatformUser()"
        class="blank-form-item"
      ></el-form-item>
      <el-form-item label="英文名" prop="name_en" class="long">
        <el-input v-model="model.name_en" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="SAP Code">
        <el-input
          v-model="model.sap_code"
          placeholder="请输入SAP Code"
        ></el-input>
      </el-form-item>
      <el-form-item label="客户状态">
        <el-select
          v-model="model.customer_status"
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option
            v-for="(value, index) in CustomerStatusMap"
            :key="index"
            :label="value"
            :value="parseInt(index)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="客户类别">
        <el-select
          v-model="model.category_id"
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option
            v-for="(value, name) in DealerCategories"
            :key="name"
            :label="value"
            :value="parseInt(name)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="授权服务商" prop="is_fix_dealer" class="long">
        <el-select v-model="model.is_fix_dealer" class="long">
          <el-option :key="0" label="否" :value="0"></el-option>
          <el-option :key="1" label="是" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="电话销售" class="long">
        <telesale-select
          :val="model.telesale_id"
          :role="FunctionalRoles.Telesale"
          @change="model.telesale_id = $event"
          style="width: 100%"
        ></telesale-select>
      </el-form-item>
      <el-form-item label="销售(服务)">
        <sale-select
          :val="model.user_id"
          :role="FunctionalRoles.Sale"
          @change="model.user_id = $event"
          style="width: 100%"
        ></sale-select>
      </el-form-item>
      <el-form-item label="级别(服务)">
        <el-select
          v-model="model.rank"
          filterable
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option
            v-for="(value, name) in DealerRanks"
            :key="name"
            :label="value"
            :value="parseInt(name)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="销售(工业)">
        <sale-select
          :val="model.industry_sale_id"
          :role="FunctionalRoles.Sale"
          @change="model.industry_sale_id = $event"
          style="width: 100%"
        ></sale-select>
      </el-form-item>
      <el-form-item label="级别(工业)">
        <el-select
          v-model="model.rank_industry"
          filterable
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option
            v-for="(value, name) in DealerRanks"
            :key="name"
            :label="value"
            :value="parseInt(name)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="销售(科学)">
        <sale-select
          :val="model.science_sale_id"
          :role="FunctionalRoles.Sale"
          @change="model.science_sale_id = $event"
          style="width: 100%"
        ></sale-select>
      </el-form-item>
      <el-form-item label="级别(科学)">
        <el-select
          v-model="model.rank_science"
          filterable
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option
            v-for="(value, name) in DealerRanks"
            :key="name"
            :label="value"
            :value="parseInt(name)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系人姓名" prop="contact_name">
        <el-input v-model="model.contact_name" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="联系人手机号" prop="contact_mobile">
        <el-input
          v-model="model.contact_mobile"
          autocomplete="off"
          maxlength="11"
          placeholder="联系人手机号"
        ></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input
          v-model="model.email"
          autocomplete="off"
          placeholder="邮箱"
        ></el-input>
      </el-form-item>
      <el-form-item label="OM邮箱" prop="email">
        <el-input
          v-model="model.om_email"
          autocomplete="off"
          placeholder="OM邮箱"
        ></el-input>
      </el-form-item>
      <el-form-item size="small" label="直销客户" v-if="auth.isPlatformUser()">
        <el-radio v-model="model.special_mark" :label="1">直销</el-radio>
        <el-radio v-model="model.special_mark" :label="2">间销</el-radio>
        <el-radio v-model="model.special_mark" :label="0">其他</el-radio>
      </el-form-item>
      <el-form-item size="small" label="重点客户" v-if="auth.isPlatformUser()">
        <el-radio v-model="model.important" :label="1">否</el-radio>
        <el-radio v-model="model.important" :label="2">是</el-radio>
      </el-form-item>
      <el-form-item label="区域" v-if="auth.isPlatformUser()">
        <area-select
          :val="model.area_id"
          @change="model.area_id = $event"
        ></area-select>
      </el-form-item>
      <el-form-item label="地区">
        <el-cascader
          size="small"
          class="long"
          :options="regionData"
          v-model="model.area"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="地址">
        <el-input v-model="model.address_detail" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item size="small" label="所属行业" prop="industry">
        <el-autocomplete
          size="small"
          class="inline-input"
          v-model="model.industry"
          :fetch-suggestions="industryQuery"
          placeholder="请输入所属行业"
        ></el-autocomplete>
      </el-form-item>
      <el-form-item label="规模" size="small" prop="scale">
        <el-input
          size="small"
          v-model="model.scale"
          placeholder="请输入规模"
        ></el-input>
      </el-form-item>
      <el-form-item label="来源" size="small" prop="source">
        <el-input
          size="small"
          v-model="model.source"
          placeholder="请输入来源"
        ></el-input>
      </el-form-item>
      <el-form-item label="代理人姓名" prop="agent_name">
        <el-input
          v-model="model.agent_name"
          placeholder="代理人姓名"
          autocomplete="off"
        ></el-input>
      </el-form-item>

      <el-form-item label="代理人手机号" prop="agent_mobile">
        <el-input
          v-model="model.agent_mobile"
          autocomplete="off"
          maxlength="20"
          placeholder="代理人手机号"
        ></el-input>
      </el-form-item>
      <el-form-item label="EC有效期" prop="ec_deadline">
        <el-date-picker
          style="width: 100%"
          v-model="model.ec_deadline"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="submitForm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  createItem,
  updateItem,
  itemCategoryList,
  supplierList,
} from '@/service/getData'
import { regionData } from '@/util/area_tool'
import { createDealer, updateDealer } from '@/service/getData'
import { clone } from '@/util'
import {
  DealerRanks,
  DealerCategories,
  FunctionalRoles,
  CustomerStatusMap,
  CsutomerIndustries,
} from '@/config/global.js'
import auth from '@/util/auth'
import SaleSelect from '@/components/select/sale_select'
import TelesaleSelect from '@/components/select/telesale_select'
import AreaSelect from '@/components/select/area_select'

export default {
  components: { SaleSelect, TelesaleSelect, AreaSelect },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
    // 'model.category': function() {
    //   this.model.item_category_id = ''
    // }
  },
  created() {
    this.industries = CsutomerIndustries.map((item) => {
      return {
        value: item,
      }
    })
  },
  data() {
    return {
      FunctionalRoles,
      auth,
      regionData,
      DealerRanks,
      DealerCategories,
      CustomerStatusMap,
      visible: this.show,
      rules: {
        name: [
          { required: true, message: '请填写该项', trigger: 'blur' },
          {
            min: 2,
            max: 15,
            max: 100,
            message: '长度在 2 到 100 个字符',
          },
        ],
        contact_name: [
          { required: true, message: '请填写该项', trigger: 'blur' },
          {
            min: 2,
            max: 40,
            message: '长度在 2 到 40 个字符',
            trigger: 'blur',
          },
        ],
        contact_mobile: [
          {
            required: true,
            pattern: /^1\d{10}$/,
            message: '手机号错误',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let area = this.model.area
          if (area.length > 0) {
            this.model.province_id = area[0]
          }
          if (area.length > 1) {
            this.model.city_id = area[1]
          }
          if (area.length > 2) {
            this.model.county_id = area[2]
          }

          if (this.model.id > 0) {
            let res = await updateDealer(this.model)
            if (res.code == 0) {
              this.$emit('updated', res.data)
              this.visible = false
            }
          } else {
            let res = await createDealer(this.model)
            if (res.code == 0) {
              this.$emit('created', res.data)
              this.visible = false
            }
          }
        }
      })
    },

    industryQuery(queryString, cb) {
      var results = queryString
        ? this.industries.filter(this.createFilter(queryString))
        : this.industries
      cb(results)
    },
    createFilter(queryString) {
      return (industry) => {
        return (
          industry.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        )
      }
    },
  },
}
</script>

<style scoped>
.el-autocomplete {
  width: 100%;
}
</style>